import styled from '@emotion/styled';
import { Slider as MuiSlider } from '@mui/material';

const StyledSlider = styled(MuiSlider)`
  ${({ theme }) => `
    color: ${theme.palette.primary.main};
    background-color: ${theme.palette.common.white};
    margin-bottom: 22px;
    .MuiSlider-rail {
      color: ${theme.palette.grey[40]};
      opacity: 1;
    }
    .MuiSlider-track {
      color: ${theme.palette.primary.main};
    }
    .MuiSlider-markLabel {
      top: 28px;
    }
    &.Mui-disabled {
      .MuiSlider-rail {
        color: ${theme.palette.grey[5]};
        opacity: 1;
      }
      .MuiSlider-track {
        color: ${theme.palette.grey[60]};
      }
      .MuiSlider-markLabel {
        color: ${theme.palette.grey[60]};
      }
    }
    .MuiSlider-thumb {
      width: 16px;
      height: 16px;
      &:focus, &:hover, &.Mui-active, &.Mui-focusVisible {
        box-shadow: 0 0 0 4px #F2F2FD;
      }
    }
    & .MuiSlider-mark {
      display: none;
    }
    .MuiSlider-valueLabel.MuiSlider-valueLabelOpen {
      transform: translateY(100%) scale(1);
      background: ${theme.palette.common.white};
      color: ${theme.palette.text.primary};
      padding-top: 0;
      line-height: 1.4rem;
      margin-top: 16px;
    }
    .MuiSlider-valueLabelLabel {
      color: ${theme.palette.primary.main};
      font-weight: 600;
    }
    .MuiSlider-valueLabelOpen:before {
      display: none;
    }
  `}
`;

export const Slider = StyledSlider;
